// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1YhZt","label":"LabeledBox_label__54ceZ"};